export default "__VITE_ASSET__345633c0__"